import { HeadWeightLocationBackDto, HeadWeightNumberBackDto, HeadWeightLocationLookup, HeadWeightNumberLookup, TourBagIronDetail } from '@/api/models';

export type BackWeightFields = Pick<TourBagIronDetail, 'headWeightLocationBackLookupId' | 'headWeightLocationBackLookupName' | 'headWeightNumberBackLookupId' | 'headWeightNumberBackLookupName'>;

export interface BackWeightData {
  locations: HeadWeightLocationBackDto[];
  numbers: HeadWeightNumberBackDto[];
  locationLookups: HeadWeightLocationLookup[];
  numberLookups: HeadWeightNumberLookup[];
}

export const emptyBackWeight: BackWeightFields = {
  headWeightLocationBackLookupId: null,
  headWeightLocationBackLookupName: '',
  headWeightNumberBackLookupId: null,
  headWeightNumberBackLookupName: '',
};

export const getBackWeightFields = (iron: BackWeightFields): BackWeightFields => ({
  headWeightLocationBackLookupId: iron.headWeightLocationBackLookupId ?? null,
  headWeightLocationBackLookupName: iron.headWeightLocationBackLookupName || '',
  headWeightNumberBackLookupId: iron.headWeightNumberBackLookupId ?? null,
  headWeightNumberBackLookupName: iron.headWeightNumberBackLookupName || '',
});

export const getBackWeightNumbers = (headModelId: number | undefined, data: BackWeightData) => {
  const lookupIds = data.numbers.filter((row) => row.headModelId === headModelId).map((row) => row.lookupId);
  return data.numberLookups.filter((row) => lookupIds.includes(row.headWeightNumberLookupId));
};

export const getBackWeightLocation = (headModelId: number | undefined, data: BackWeightData) => {
  const lookupIds = data.locations.filter((row) => row.headModelId === headModelId).map((row) => row.lookupId);
  return data.locationLookups.find((row) => lookupIds.includes(row.headWeightLocationLookupId) && row.name.toLowerCase() === 'flat');
};

export const selectBackWeight = (headModelId: number | undefined, numberId: string, data: BackWeightData): BackWeightFields => {
  const number = getBackWeightNumbers(headModelId, data).find((row) => row.headWeightNumberLookupId.toString() === numberId);
  const location = getBackWeightLocation(headModelId, data);
  if (!number || !location) return { ...emptyBackWeight };
  return {
    headWeightLocationBackLookupId: location.headWeightLocationLookupId,
    headWeightLocationBackLookupName: location.name,
    headWeightNumberBackLookupId: number.headWeightNumberLookupId,
    headWeightNumberBackLookupName: number.name,
  };
};

// Prototype only: populate once the label-to-grams mapping is confirmed.
// Deliberately not connected to calculateFinalHeadWeight.
const backWeightGrams: ReadonlyMap<string, number> = new Map();
export const getBackWeightAdjustment = (name: string): number | undefined => backWeightGrams.get(name);
